<template>
  <div class="wrapPop" v-if="isShow">
    <div class="box">
      <div class="avator">
        <img src="../assets/images/img_77.png" alt="" />
      </div>
      <div class="title">温馨提示</div>
      <div class="content">
        亲爱的钱大师用户们，因苹果最新版系统（14.5版本）出现广告跟踪兼容性问题，会影响您的正常试玩，建议暂时不要更新，耐心等待苹果优化升级，感谢配合和支持！
      </div>
      <div class="btn" @click="handleClose">好的</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
    };
  },
  mounted() {
     setTimeout(()=> this.time('point'),1800)
  },
  methods: {
    handleClose() {
      this.isShow = false;
    },
    getYearMonthDate() {
      let time = new Date();
      return (
        time.getFullYear() + "-" + (time.getMonth() + 1) + "-" + time.getDate()
      );
    },
    time(str) {
      if (localStorage.getItem(str)) {
        this.timeTag = localStorage.getItem(str);
        if (this.timeTag !== this.getYearMonthDate()) {
          this.isShow = true;
          localStorage.setItem(str, this.getYearMonthDate());
        }
      } else {
        this.isShow = true;
        localStorage.setItem(str, this.getYearMonthDate());
      }
    },
  },
};
</script>

<style lang="less" scoped>
/* 通用样式 弹窗*/
.wrapPop {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.72);
  z-index: 200;
  .box {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 280px;
    height: 365px;
    background: #fff;
    border-radius: 10px;
    .avator {
      width: 82px;
      height: 82px;
      padding: 10px;
      background: #fff;
      border-radius: 50%;
      margin-top: -41px;
      box-sizing: border-box;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .title {
      font-size: 22px;
      font-weight: 500;
      margin: 18px 0;
    }
    .content {
      padding: 0 32px 0;
      line-height: 22px;
      font-size: 16px;
      color: rgb(87, 84, 84);
    }
    .btn {
      width: 149px;
      height: 53px;
      background: #f55d4f;
      color: #fff;
      font-size: 18px;
      line-height: 53px;
      text-align: center;
      border-radius: 42px;
      margin-top: 34px;
    }
  }
}
</style>